import actionTypes from 'SRC/modules/redux/actionTypes'

export const updateServiceProviderPhotoByTmpId = (tmpId, photo) => ({
  type: actionTypes.UPDATE_SERVICE_PROVIDER_PHOTO_BY_TMP_ID,
  payload: {tmpId, photo}
})
